/* The Antique Parlour — product photo reading glass (v1) */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var Z = 2.5;
  function attach(wrap) {
    if (wrap.getAttribute('data-pl')) return;
    wrap.setAttribute('data-pl', '1');
    var img = wrap.querySelector('img.photoswipe__image');
    if (!img) return;
    var src = img.getAttribute('data-photoswipe-src');
    if (!src) return;
    var lens = document.createElement('span');
    lens.className = 'pl-loupe';
    lens.setAttribute('aria-hidden', 'true');
    wrap.appendChild(lens);
    wrap.classList.add('pl-wrap');
    var loaded = false;
    function off() { lens.classList.remove('is-on'); wrap.classList.remove('pl-active'); }
    function move(e) {
      var r = wrap.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height || !r.width) { off(); return; }
      var L = lens.offsetWidth || 150;
      if (!loaded) { lens.style.backgroundImage = 'url("' + src + '")'; loaded = true; }
      lens.style.backgroundSize = (r.width * Z) + 'px ' + (r.height * Z) + 'px';
      lens.style.backgroundPosition = (L / 2 - x * Z) + 'px ' + (L / 2 - y * Z) + 'px';
      lens.style.transform = 'translate(' + (x - L / 2) + 'px,' + (y - L / 2) + 'px)';
      lens.classList.add('is-on');
      wrap.classList.add('pl-active');
    }
    wrap.addEventListener('mousemove', move);
    wrap.addEventListener('mouseleave', off);
    // a click on the photo opens the theme's full-screen viewer
    wrap.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.product__photo-zoom')) return;
      var b = wrap.querySelector('.js-photoswipe__zoom');
      if (b) { off(); b.click(); }
    });
  }
  document.addEventListener('mouseover', function (e) {
    var w = e.target && e.target.closest ? e.target.closest('.product-image-main .image-wrap') : null;
    if (w) attach(w);
  });
})();
